import {useCallback} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {PaginatedResponseV2} from "../../../types/PaginatedResponse";
import {AudioFile} from "../typedefs";

type AudioFilesResult = PaginatedResponseV2<AudioFile>;

export function useGetAudioFiles(clientID: string | null) {
    return useCallback(async (search: string, page: number): Promise<AudioFilesResult | null> => {
        const res = await platformAPI.get<AudioFilesResult>("api/siren/audio-files", {
            params: {page, limit: 10, search, ...(clientID ? {clientID} : {})},
        });
        const {results, hasMore, currentPage} = res.data;
        return {results, hasMore, currentPage};
    }, [clientID]);
}
